// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","Container":"App_Container__10KOh","EdYodaLogo":"App_EdYodaLogo__3799h"};